import { Divider } from '@any-ui-react/core';

import { CrmRichTextEditorInlineState } from '../../CrmRichTextEditor';
import { AlignmentSelect } from '../alignment';
import { BoldButton } from '../bold';
import { EmojiPopover } from '../emoji';
import { FontSizeSelect } from '../font-size';
import { VariableDropdown } from '../variable';

export interface ToolbarPluginProps extends CrmRichTextEditorInlineState {
  withInlineState?: boolean;
  withVariable?: boolean;
}

export const ToolbarPlugin = ({
  fontSize,
  weighted,
  align,
  withInlineState,
  withVariable,
}: ToolbarPluginProps) => {
  return (
    <div className="bg-gray-0 relative flex items-center gap-x-2 p-2">
      {withInlineState && <FontSizeSelect value={fontSize} />}
      <div className="flex items-center gap-x-1">
        {withInlineState && <BoldButton isBold={weighted} />}
        {withInlineState && <AlignmentSelect alignment={align} />}
        <EmojiPopover />

        {withVariable && (
          <>
            <Divider orientation="vertical" />
            <VariableDropdown mode="toolbar" />
          </>
        )}
      </div>
    </div>
  );
};
